import { cn } from '@/lib/utils';

const ONLY_ROOM_NUMBER = /^\d+(?:[.\-/]\d+)?[a-zA-Z]?$/;
const TRAILING_ROOM_NUMBER = /^(.*?)(\s+)(\d+(?:[.\-/]\d+)?[a-zA-Z]?)$/;

export function splitRoomNameAndNumber(name: string): { prefix: string; roomNumber: string | null } {
    const trimmed = name.trim();
    if (!trimmed) {
        return { prefix: '', roomNumber: null };
    }
    if (ONLY_ROOM_NUMBER.test(trimmed)) {
        return { prefix: '', roomNumber: trimmed };
    }
    const match = trimmed.match(TRAILING_ROOM_NUMBER);
    if (match) {
        return { prefix: match[1] + match[2], roomNumber: match[3] };
    }
    return { prefix: trimmed, roomNumber: null };
}

type RoomNameProps = {
    name: string;
    categoryName?: string | null;
    className?: string;
};

export function RoomName({ name, categoryName, className }: RoomNameProps) {
    const { prefix, roomNumber } = splitRoomNameAndNumber(name);

    return (
        <span className={cn('flex min-w-0 max-w-full flex-col', className)}>
            <span className="inline-flex min-w-0 items-baseline">
                {roomNumber ? (
                    <>
                        {prefix ? <span className="min-w-0 truncate">{prefix}</span> : null}
                        <span className="shrink-0">{roomNumber}</span>
                    </>
                ) : (
                    <span className="whitespace-normal break-words">{prefix || name}</span>
                )}
            </span>
            {categoryName ? (
                <span className="text-[10px] leading-none text-muted-foreground">
                    {categoryName}
                </span>
            ) : null}
        </span>
    );
}
